/* ------- MICROFRONT - PLP ------- */
import type { RouteLocation } from '#vue-router'
import { PAGE_ANALYTICS_INFO, PAGE_TYPE } from '../../router/page-types'

const plpRouteConfig = {
  component: () => import('@b2ag/micro-front-plp/app'),
  props: (route: RouteLocation) => ({
    microFrontName: 'plp',
    viewName: 'default',
    categorySlug: route.params.slug,
    virtualCategorySlug: route.params.virtualCategorySlug,
  }),
  meta: {
    private: false,
    showSelectedCustomer: true,
    showSearchBar: true,
    analyticsPageType: PAGE_TYPE.SEARCH_RESULT,
    analyticsPageInfo: PAGE_ANALYTICS_INFO.SEARCH_RESULTS,
    disabledLayoutAlternate: true,
  },
}

const plpSearch = {
  ...plpRouteConfig,
  name: 'search',
  props: (_route: RouteLocation) => ({
    microFrontName: 'plp',
    viewName: 'default',
    categorySlug: undefined,
  }),
}

const plpCategory = {
  ...plpRouteConfig,
  name: 'category',
  props: (route: RouteLocation) => ({
    microFrontName: 'plp',
    viewName: 'default',
    categorySlug: route.params.slug,
  }),
}

export const plpRoutes = [
  {
    name: 'plp-virtual-category',
    path: '/category-lp/:virtualCategorySlug',
    ...plpRouteConfig,
  },
  {
    path: '/products',
    alias: ['/search'],
    ...plpSearch,
  },
  {
    path: '/category/:slug',
    ...plpCategory,
  },
]
